/* eslint-disable react/button-has-type */
import React, { ButtonHTMLAttributes, memo } from 'react';
import useStyles from './styles';

interface IBigButtonNext {
    content: string;
    style?: object;
    type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
    isDisabled?: boolean,
    handleSubmit?: () => void,
}


const BigButtonNext : React.FC<IBigButtonNext> = ({
  content, type = 'button', isDisabled = false, style, handleSubmit,
}) => {
  const classes = useStyles();
  const handleClick = () => {
    handleSubmit && handleSubmit();
  };
  return (
    <button type={type} className={classes.btn} disabled={isDisabled} style={style || {}} onClick={handleClick}>
      <span>{content}</span>
    </button>
  );
};

export default memo(BigButtonNext);
